<template>
  <v-card outlined loading="isLoadingEvents">
    <v-stepper v-model="pageIndex">
      <v-stepper-header>
        <v-stepper-step
          :complete="pageIndex > 1"
          step="1"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Motivo assenza
        </v-stepper-step>
        
        <v-divider></v-divider>
        <v-stepper-step
          :complete="pageIndex > 2"
          step="2"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Data e Ora
        </v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="2">
          <div class="mb-12">
            <StepDataOra
              ref="StepDataOra"
              v-bind:eventInfo="evento"
            ></StepDataOra>
          </div>
        </v-stepper-content>
        <v-stepper-content step="1">
          <div class="mb-12">
            <h3>{{absenceTitle}}</h3>
              <v-select
          :items="absenceReasons"
          :label="absenceDescription"
          item-value="value"
          item-text="description"
          v-model="absenceReason" 
        />
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn text @click="pageIndex--" v-if="pageIndex > 1"> Indietro </v-btn>
      <v-spacer></v-spacer>

      <v-btn
        v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        @click="pageIndex++"
        v-if="pageIndex < 2"
        :disabled="isLoadingEvents"
      >
        Avanti
      </v-btn>
     
      <v-btn
        color="success"
        depressed
        @click="submitEvent"
        v-if="
          pageIndex == 2 &&
          (evento.idIntervento == 0 || evento.idIntervento == undefined)
        "
      >
        Fine
      </v-btn>
      <v-btn
        color="success"
        depressed
        @click="updateEvent"
        v-if="pageIndex == 6 && evento.idIntervento > 0"
      >
        Modifica evento
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import StepCustomerHeadquarter from "./Steps/StepCustomerHeadquarter.vue";
import FrmSelectResources from "./FrmSelectResources";
import StepDataOra from "./Steps/StepDataOra.vue";
import EasyPlanClient from "../../utils/EasyPlanClient";
import StepFormOperatore from "./Steps/StepFormOperatore.vue";
import StepEquipments from "./Steps/StepEquipments.vue";
import StepVehicles from "./Steps/StepVehicles.vue";
import StepEventInfo from "./Steps/StepEventInfo.vue"; 
import moment from "moment";

import UISettingsHelper from "../../utils/UISettingsHelper";
export default {
  props: {
    absenceReasons:[],
    absenceTitle:[],
    absenceDescription:[],
   
    evento: {
      type: Object,
      default: function () {
        return {
          commessa: {
            descrizione: "",
          },
          descrizione: "this is a description",
          note: "",
          risorse: [],
          idCliente: 0,
          sedeId: 0,
          inizio: new Date(),
          fine: new Date(),
          giornoIntero: false,
          lampeggia: false,
        };
      },
    },
  },

  data() {
    let data = {
      isLoadingEvents: false,
      pageIndex: 1,
      events: [],
      absenceReason:"",
      //   Descrizione: "this is a description",
      //   Risorse: [],
      //   idCliente: 0,
      //   sedeId: 0,
      //   Note: "",
      //   Inizio: new Date(),
      //   Fine: new Date(),
      //   GiornoIntero: false,
      // },
    };
    return data;
  },
  components: {
    StepCustomerHeadquarter,
    StepDataOra,
    StepFormOperatore,
    StepEquipments,
    StepVehicles,
    StepEventInfo,
    FrmSelectResources,
  },
  watch: {
    event: function (value, old) {
      if (old.idIntervento != value.idIntervento) this.pageIndex = 1;
      // console.debug("event changed");
      // console.debug(value);
      this.evento = value;
      // this.$forceUpdate();
    },
    evento(value, old) {
      if (value != null) {
        if (old.idIntervento != value.idIntervento) this.pageIndex = 1;
      } else {
        this.pageIndex = 1;
      }
      this.loadEvents(value.inizio);
    },
  },
  methods: {
    checkData() {
      console.debug("check if it can go farward");
      return true;
    },
    cmdSkip_Click() {
      if (!this.isLoadingEvents) this.checkData();
    },
    loadEvents(inizio) {
      this.pageIndex = 1;
      this.isLoadingEvents = true;
      console.log("loading workers...");
      EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
        this.$route.params.companyAlias,
        inizio,
        inizio
      )
        .then((res) => {
          this.events = res.data.data;
          console.log(this.events);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.isLoadingEvents = false;
        });
    },
    ReloadSelectedOperatorsFromSteps() {
      console.debug("carico operatori");
      let selectedOperators =
        this.$refs.StepSelectOperators.GetSelectedResources();
      this.evento.risorse = this.evento.risorse.filter((r) => r.tipo != "Uomo");
      this.evento.risorse.push(...selectedOperators);
    },
    ReloadEventDataFromSteps() {
      console.debug("carico dati evento da steps");
      this.ReloadSelectedOperatorsFromSteps();
        this.ReloadSelectedEquipmentsFromSteps();
        this.ReloadSelectedVehiclesFromSteps();
    },
    submitEvent: function () {
      if (this.checkData()) { 
        //this.ReloadSelectedOperatorsFromSteps();
        //this.ReloadSelectedEquipmentsFromSteps();
       // this.ReloadSelectedVehiclesFromSteps();
        console.debug("evento.risorse",this.evento.risorse);
        this.evento.descrizione=this.absenceReason;
        this.evento.risorseIntervento = [];
        // this.evento.inizio=moment(this.evento.inizio ).format("MM/DD/YYYY HH:mm");
        // this.evento.fine=moment(this.evento.fine ).format("MM/DD/YYYY HH:mm");
        for (var i = 0; i < this.evento.risorse.length; i++)
          this.evento.risorseIntervento.push({
            idRisorsa: this.evento.risorse[i].idRisorsa,
          });
          
        console.debug("evento.risorseIntervento",this.evento.risorseIntervento);
        let tmp = { ...this.evento };
        this.evento.cliente = null;
        this.$emit("eventAdding", tmp);
        EasyPlanClient.Event.Insert(
          this.$route.params.companyAlias,
          this.evento
        )
          .then((res) => {
            console.debug("risposta add absence:");
            console.debug(res);
            this.evento.risorse = [];
            this.$emit("eventAdded", res.data.data);
            // this.users.push(res.data.data);
            // this.loadUsers();
          })
          .catch((error) => {
            console.log(error);
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          });
      }
    },
    updateEvent: function () {
      if (this.checkData()) {
        this.ReloadSelectedOperatorsFromSteps();
        console.debug("Aggiorno intervento");
        // this.evento.inizio=this.evento.inizio.toLocaleString();
        // this.evento.fine=this.evento.fine.toLocaleString();
        this.evento.risorseIntervento = [];
        for (var i = 0; i < this.evento.risorse.length; i++)
          this.evento.risorseIntervento.push({
            idRisorsa: this.evento.risorse[i].idRisorsa,
          });
        EasyPlanClient.Event.Update(
          this.$route.params.companyAlias,
          this.evento.idIntervento,
          this.evento
        )
          .then((res) => {
            console.debug("risposta update event:");
            console.debug(res);
            this.evento.risorse = [];
            this.$emit("eventUpdated", res.data.data);
            // this.users.push(res.data.data);
            // this.loadUsers();
          })
          .catch((error) => {
            console.log(error);
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          });
      }
    },
  },
computed:{
   
    UISettings(){
      UISettingsHelper.LoadSettings();
      return UISettingsHelper.GetSettings();
  },
},
  mounted() {
    // this.evento = this.event;
  },
  async created() {
  UISettingsHelper.Configure(this.$route.params.companyAlias);  
    if (this.evento.commessa == undefined)
      this.evento.commessa = { descrizione: "" };
    this.loadEvents(this.evento.inizio);
  },
};
</script>